import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p className="footer-text">
        Made with <a href="https://geniusnet.ai" target="_blank" rel="noopener noreferrer" className="footer-link">GeniusNET AI</a>
      </p>
    </footer>
  );
}

export default Footer;

